import { Avatar, ListItemAvatar, Paper, Typography } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'

export default function SunnyMessage({ message,ms }: any) {

  return (
    <>
      <ListItemAvatar>
        <Avatar sx={{ 
                position: 'absolute', 
                left: '35px', 
                bottom: '0px', 
                height: '30px',
                width: '30px'
            }} alt="Sunny" 
            src="/images/aiLogo.jpg" />
      </ListItemAvatar>
      <Paper sx={{ 
          p: custom.spacing.sm, 
          mr: { xs:2, sm:2, md:5, lg:10 }, 
          borderRadius: '16px 16px 16px 0' 
          }} >
        <Typography variant='szBody.Regular.Small'>
          {message}
        </Typography>
      </Paper>
    </>     
  )
}
